export const loginErrors = {
  'auth/invalid-email': 'La dirección de email no esta en su formato correcto',
  'auth/user-disabled': 'Este usuario se encuentra deshabilitado',
  'auth/user-not-found': 'Este usuario no existe',
  'auth/wrong-password': 'Si clave no es correcta',
  'auth/user-token-expired': 'Su token ha expirado',
};
